export function scrollToTarget(scroller, target) {
    scroller.scrollTo({
        top: 0,
        left: target.getBoundingClientRect().left,
        behavior: 'smooth'
    });
}
